<template>
  <div class="config-fee-wrapper">
    <h2>设置医事服务费</h2>
    <div class="fee-typer-box">
      <div class="typer-container">
        <span class="label">医事服务费</span>
        <number-input class="fee-typer" placeholder="请输入金额" v-model="configFee" :min="0.00" />
      </div>
      <span class="unit">元/次</span>
    </div>
   <h2 v-if="userInfo.doctor_type == 1">自定义星级评定</h2>
    <div class="pingfen" v-if="userInfo.doctor_type == 1">
      <div class="content">
        <div class="stars" >
          <span v-for="(item, index) in spanList" :key="index" :class="{'show2':item.selected}" @click="setStar(index)"></span>
        </div>
        <!--
        <div class="stars">
          <span @click="setStar(0)"></span>
          <span @click="setStar(1)"></span>
          <span @click="setStar(2)"></span>
          <span @click="setStar(3)"></span>
          <span @click="setStar(4)"></span>
        </div>
        -->

      </div>
         <div class="info"><div class="tip_text">{{star_tip}}</div></div>
    </div>
    <div class="save-fee"><button class="save-fee-button" @click="submit" >保存设置</button></div><!--:disabled="!feeChanged"-->
  </div>
</template>

<style lang="less" scoped>

  .config-fee-wrapper{
    min-height: 100vh;
    background: #F7F7F7;
    padding-top: 22px;
    h2{
      font-size: 16px;
      line-height: 20px;
      color: @black;
      font-weight: bold;
      padding: 0 20px;
      margin-top: 10px;
      margin-bottom: 5px;
    }
    .fee-typer-box{
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      background: #FFF;
      padding: 0 20px;
      height: 50px;
      font-size: 16px;
      color: #666;
      margin-top:5px;
      .typer-container{
        display: flex;
        justify-content: flex-start;
        align-items: center;
      }
      .label, .unit{
        flex-shrink: 0;
      }
      .fee-typer{
        flex: 1;
        padding: 15px 16px;
        font-size: 16px;
        line-height: 20px;
        color: #333;
      }
    }
    .save-fee{
      width: 220px;
      margin: 36px auto;
      .save-fee-button{
        @button-base();
        width: 100%;
        height: 36px;
        &:disabled{
          background: #CCC;
        }
      }
    }
    .pingfen {
      width:100%;
      margin: 5px auto 0px auto;
      border-radius: 5px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      background: #fff;
      .content {
        width: 92%;
        margin:auto;
        margin-top: 20px;
      }
      .stars {
        list-style: none;
        margin: 0;
        color: #ccc;
        display: flex;
        flex-direction:row;
        justify-content:flex-start;
        align-items:left;

      }
      .stars span {
        margin-left:13px;
        width: 41px;
        height: 37px;
        background: url('data:image/png;base64,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') no-repeat center center;
        background-size: 31px 27px;
      }
      .stars .show2 {
        margin-left:13px;
        width: 41px;
        height: 37px;
        background: url('data:image/png;base64,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') no-repeat center center;
        background-size: 31px 27px;
      }
      .info {
        font-size: 14px;
        margin-top: 20px;
        text-align: left;
        background-color: #efefef;
        min-height: 100px;
        .tip_text {
          width: 90%;
          margin:1px auto;
          height: 58px;
          text-align: left;
          color: #7b7b7b;
          line-height: 25px;
        }
      }
    }
  }
</style>

<script type="text/javascript">
  import numberInput from '@/components/Common/numberInput'
  export default {
    data() {
      return {
        oldFee: '',
        configFee: 0,
        feeChanged: false,
        submitting: false,
        service_score: 0,
        spanList: [{
            'selected': 0,
            'tips':'一星服务:您将提供简易的门诊服务，医院按简易门诊的服务标准给您进行考核，但会在标准分的基础上扣减10%。'
          },
          {
            'selected': 0,
            'tips':'二星服务:您将提供二星的服务，医院会按二星的服务标准对您进行考核。'
          },
          {
            'selected': 0,
            'tips':'三星服务:您承诺愿意提供三星级的服务，医院会按三星的服务标准对您进行考核，如确实达到了三星的标准，医院会在您的基础分上增加10%考核分。'
          },
          {
            'selected': 0,
            'tips':'四星服务:您承诺愿意提供四星级的服务，医院会按四星的服务标准对您进行考核，如确实达到了四星的标准，医院会在您的基础分上增加20%考核分。'
          },
          {
            'selected': 0,
            'tips':'五星服务:您承诺愿意提供五星级的服务，医院会按五星的服务标准对您进行考核，如确实达到了五星的标准，医院会在您的基础分上增加30%考核分。'
          }
        ],
        star_tip:""
      }
    },
    components: {
      numberInput
    },
    watch: {
      /*
      configFee(value) {
        if (parseFloat(value) == this.oldFee) {
          this.feeChanged = false;
        } else {
          this.feeChanged = true;
        }
      } */
    },

    computed: {
      userInfo() {
        console.log(this.$store.state.userInfo)
        return this.$store.state.userInfo
      }
    },
    created() {
      this.setStar(this.service_score-1);
      this.$root.post('/getDoctorMoney', {
        doc_id: this.userInfo.user_id
      }).then(data => {
        console.log(data)
       // this.oldFee = parseFloat(data) / 100;
        this.configFee = parseFloat(data.money) / 100;
        this.service_score=data.star;
        this.setStar(this.service_score-1);
      })
    },
    methods: {
      setStar(current) {
        let _this = this;
        _this.star_tip="";
        this.spanList.forEach(item => {
          item.selected = 0;
        })
        this.spanList.forEach(function(item, index) {
            if (index <= current) {
              item.selected = 1;
              _this.star_tip=item.tips;
            }
        })
        _this.service_score = current + 1;

      },

      submit() {
        this.$toast.loading({
          duration: 0,
          forbidClick: true,
          loadingType: 'spinner',
          message: '提交中...'
        })
        this.$root.post('/setDoctorMoney', {
          doc_id: this.userInfo.user_id,
          money: this.configFee,
          star:this.service_score
        }).then(data => {
          this.$toast.clear();
          if (data.status == 1) {
            this.$notify({
              background: '#00848A',
              message: '设置成功'
            })
            this.$router.go(-1);
          } else {
            this.$notify(data.msg);
          }
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Doctor/Mine/medicalFeeConfig.vue